import React from 'react'
import common from '../methods/common'
// import CONSTANTS from '../CONSTANTS'
// import clients from "../database/leads_by_be.json"
import clients from "../database/monthlyJSON/2022_7to2023_3_7.json"

const Downloads = () => {
    console.log(clients)
    // let data = CONSTANTS.documentsConfigs
    // let arr = []
    let dup = []
    
    // let get = "mobile" //"email"

    return (
        <div className='download df-jc'>
            <div className='download-section'>
                <h3 className='title'>Testing</h3>
                <div>
                    {common.getUniqueMobileNumbersFromImData(clients).map(item=> <p><span>{item}</span>,</p>)}
                    {/* {clients.map((item, i)=>{
                        if(get === "mobile"){
                            if(!item.SENDER_MOBILE || item.SENDER_MOBILE.length<10){
                                return null
                            }
                            return  <p><span>{item.SENDER_MOBILE}</span>,</p>
                        }
                        if(i+1<500){
                            return null
                        }
                        if(arr.includes(item.SENDER_EMAIL)){
                            dup.push(item.SENDER_EMAIL)
                        }
                        if(!arr.includes(item.SENDER_EMAIL) && item.SENDER_EMAIL){
                            arr.push(item.SENDER_EMAIL)
                            return  <p><span>{item.SENDER_NAME}</span>,<span>{item.SENDER_EMAIL}</span> </p>
                        } else{
                            // dup.push(item.SENDER_EMAIL)
                            return null
                        }

                    })} */}
                    {console.log(dup)}
                </div>
               
            </div>
        </div>
    )
}

export default Downloads


// Call to get Powder coating machines and Powder at the best prices!
// We are one of the best manufacturers of coating booths, plants, and ovens.
// We also give free suggestions to solve the problems related to the coating industry.
// Over team has 40 years of Experience in the same field. No problems are new to us.